import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "..";
import {TokenData} from "@/types/auth.ts";
import {jwtDecode} from "jwt-decode";


export type AuthState = {
    accessToken: string | null;
    refreshToken: string | null;
    logado: boolean;
    nome?: string;
}


const initialState: AuthState = {
    accessToken: null,
    refreshToken: null,
    logado: false
}


export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        login: (state, action) => {
            state.accessToken = action.payload.accessToken;
            state.refreshToken = action.payload.refreshToken;
            const tokenDecoded: TokenData = jwtDecode(action.payload.accessToken);
            state.nome = tokenDecoded.name;
            state.logado = true;
        },
        logout: (state) => {
            state.accessToken = null;
            state.refreshToken = null;
            state.logado = false;
        }
    },

})


export default authSlice.reducer

export const useAuthActions = authSlice.actions;

export const useAuthState = (state: RootState) => state.auth;